import Alpine from "alpinejs";
import shopify from "@/scripts/shopify.js";
import Airtable from "airtable";
import { ambassadorList } from "../../src/scripts/queries";
import { shuffleArray, handleize } from "@/scripts/utils";

window.Alpine = Alpine;

Alpine.data("ambassadors", () => ({
  loading: true,
  activeTab: "ambassadors",
  ambassadors: [],
  alum: [],
  events: [],

  init() {
    this.retrieveData();
    //this.retrieveEvents();
  },

  async retrieveData() {
    const variables = {
      type: "ambassador",
      sortKey: "id",
      first: 100,
      reverse: true,
    };
    const data = await shopify(ambassadorList, variables).then((data) => {
      return this.parseData(data);
    });
    this.ambassadors = data.filter((el) => el.status === "Active");
    this.alum = data.filter((el) => el.status === "Alumni");
    shuffleArray(this.ambassadors);
    //this.ambassadors = data;
    this.retrieveEvents(data);
    this.loading = false;
  },

  parseData(data) {
    return data.metaobjects.edges.map((node) => {
      return {
        id: node.node.id,
        handle: node.node.handle,
        name: node.node.name?.value,
        status: node.node.status?.value || "Active",
        location: node.node.location?.value,
        headshot: {
          ratio:
            node.node.headshot.reference.image.height /
            node.node.headshot.reference.image.width,
          ...node.node.headshot.reference.image,
        },
      };
    });
  },

  imgSrcset(img) {
    return `${img.url}&width=650 650w, ${img.url}&width=800 800w, ${img.url}&width=1000 1000w`;
  },

  async retrieveEvents(data) {
    const base = new Airtable({
      apiKey:
        "pattujLGlvL7Zx2wy.070376e27f13a8851181b7e3700ba91be3d6336022c60caec8627f1e5486dbe3",
    }).base("appsfx3lpefju964Y");
    const events = [];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const options = { weekday: "short", month: "short", day: "numeric" };
    const records = await base("Events")
      .select({
        view: "Grid view",
        filterByFormula:
          "IF(AND({Approved} = TRUE(),{Event End Date},IS_AFTER({Event End Date}, TODAY())),1,IF(AND({Approved} = TRUE(),IS_AFTER({Event Start Date}, TODAY())),1,0))",
        sort: [{ field: "Event Start Date", direction: "asc" }],
      })
      .all()
      .then((records) => {
        records.forEach(function (rec) {
          let st = new Date(rec.get("Event Start Date") + "T00:00");
          let end = new Date(rec.get("Event End Date") + "T00:00");
          let amb = data.find((ev) => {
            let name = rec.get("Full Name");
            return ev.name == name || ev.handle == handleize(name);
          });

          let ev = {
            start: {
              raw: rec.get("Event Start Date"),
              short: st.toLocaleDateString(),
              long: st.toLocaleDateString("en-us", options),
              day: st.getDate(),
              month: months[st.getMonth()],
            },
            end: {
              raw: rec.get("Event End Date"),
              short: end.toLocaleDateString(),
              long: end.toLocaleDateString("en-us", options),
              day: end.getDate(),
              month: months[end.getMonth()],
            },
            name: rec.get("Event Name"),
            type: rec.get("Event Type"),
            location: rec.get("Location"),
            website:
              rec.get("Website").startsWith("http://") ||
              rec.get("Website").startsWith("https://")
                ? rec.get("Website")
                : "https://" + rec.get("Website"),
            desc: rec.get("Description"),
            ambassador: rec.get("Full Name"),
            ambassadorHandle: amb?.handle || handleize(rec.get("Full Name")),
            headshot: amb?.headshot?.url,
          };

          events.push(ev);
        });
      })
      .catch((err) => {
        console.error(err);
      });

    this.events = events;
  },
}));

Alpine.start();
